export default __webpack_public_path__ + "static/media/unisex-avatar.e85ae8b5.svg";